import { Box, DialogTitle, Stack, Tab } from "@mui/material";
import { useState } from "react";
import { CommonDialog } from "../../../components/common/CommonDialog";
import { useContractContext } from "../../../contexts/ContractContext";

import { TabContext, TabList, TabPanel } from "@mui/lab";
import { ContractPanel } from "./ContractPanel";
import { PaymentPanel } from "./PaymentPanel";

interface IProps {
  open: boolean;
  handleClose: VoidFunction;
}

export function DetailsPlanDialog({ open, handleClose }: IProps) {
  const { setRefetchInactiveContracts } = useContractContext();
  const [tab, setTab] = useState("1");

  const handleChange = (event: React.SyntheticEvent, tabValue: string) => {
    if (tabValue === "2") setRefetchInactiveContracts((prev: boolean) => !prev);
    setTab(tabValue);
  };

  return (
    <CommonDialog isOpen={open} handleClose={handleClose}>
      <DialogTitle align="center" sx={{ padding: 0, marginBottom: 2 }}>
        Detalhes do plano de assinatura
      </DialogTitle>
      <TabContext value={tab}>
        <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
          <TabList onChange={handleChange} aria-label="lab API tabs example">
            <Tab label="Contratos" value="1" />
            <Tab label="Pagamentos" value="2" />
          </TabList>
        </Box>
        <TabPanel value="1" sx={{ p: "16px 0px" }}>
          <Stack width="100%" height="100%">
            <ContractPanel />
          </Stack>
        </TabPanel>
        <TabPanel value="2" sx={{ p: "16px 0px" }}>
          <PaymentPanel />
        </TabPanel>
      </TabContext>
    </CommonDialog>
  );
}
